<template>
  <div>
    <section class="has-listing-table">
      <div class="level-left" v-if="!viewOnlyUser">
        <span class="navbar-item no-padding">
          <h3 class="no-padding" style="margin-bottom: 4px;">Certificates</h3>
        </span>
      </div>
      <circul8-table
        @clickcheck="checkCheckBox"
        @checkedAll="checkedAllData"
        :checkedRows="checkedRows"
        :isCheckable="true"
        :records="tableData"
        :fields="columns"
        :usePropRecords="true"
        :listingComponent="true"
        :showViewButton="false"
        :maxTextLength="'24'"
        :isLoading="isDataLoading"
        @downloadFile="downloadCertificate"
        :showEditButton="false"
        @clickEdit="openEditCertificateModal"
        @clickView="openViewCertificateModal"
        @loadNextPage="pullNextPage"
        :enableInfiniteScroll="true"
        :hasNextData="nextData"
        :hasPreviousData="previousData"
        @loadPreviousPage="pullPreviousPage"
        @backendSort="sortData"
        @querySet="searchByFilter"
        :backendSortingEnabled="true"
        :routeNext="false"
        :allCustomers="customers"
        :allUsers="users"
        :isCheckAll="false"
        :allowOnlyOneSelection="true"
      />
      <div class="records-displayed" v-if="totalRecords > 0">
        <span v-if="isCheckedAll"> All selected, </span>
        <span v-if="checkedData.length > 0 && !isCheckedAll"
          >{{ checkedData.length }} selected,
        </span>
        <span v-if="currentPage * 50 + 50 < totalRecords"
          >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
          {{
            currentPage > 0
              ? nextPageCursor
                ? currentPage * 50 - 50 + tableData.length
                : totalRecords
              : tableData.length
          }}
          records out of {{ totalRecords }} records</span
        >
        <div v-else>
          <span v-if="currentPage == 0">
            displaying 0 - {{ totalRecords }} records out of
            {{ totalRecords }} records
          </span>
          <span v-else>
            displaying {{ currentPage * 50 - 50 }} - {{ totalRecords }} records
            out of {{ totalRecords }} records
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Circul8Table from "../../../components/Circul8Table.vue";
import DataManagementService from "../../../services/DataManagementImportService";
import DataManagementCertificatesService from "../../../services/DataManagementCertificatesService";
import CustomerProfileDataService from "../../../services/CustomerProfileDataService";
import UtilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import UserDataService from "@/services/UserDataService";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
import SuppliersService from "@/services/SuppliersService";
export default {
  name: "DataManagementImport",
  mixins: [UtilityMixin, ScopeMixin],
  components: {
    Circul8Table
  },
  props: {
    matchClicked: { type: Number, default: 0 }
  },
  data() {
    return {
      showCertificateModal: false,
      tableData: [],
      checkedData: [],
      checkedRows: [],
      map1: new Map(),
      isCheckedAll: false,
      showCamUserData: false,
      checkedDataMap: new Map(),
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      isDataLoading: false,
      linkView: "datamanagement.validation.product",
      customers: [],
      userDataService: new UserDataService(),
      suppliersService: new SuppliersService(),
      users: [],
      suppliers: [],
      editCertificate: null,
      viewCertificate: null,
      isManualMatchingModal: false,
      columns: [
        {
          field: "customer_name",
          label: "Customer Name",
          searchable: true,
          width: "200",
          type: "multiSelectFilter",
          visible: true,
          allStatusVals: this.customers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { customer_name: [] }
        },
        {
          field: "supplier_name",
          label: "Supplier Name",
          searchable: true,
          width: "200",
          type: "multiSelectFilter",
          visible: true,
          allStatusVals: this.suppliers,
          initStatusVals: [],
          multiSelectFilter: true,
          filterKey: { supplier_name: [] }
        },
        {
          field: "active_document_name",
          label: "Certificates",
          searchable: true,
          visible: true,
          download: true,
          downloadIcon: "mdi mdi-download",
          type: "input",
          filterKey: { active_document_name: "" }
        },
        {
          field: "expiry_date",
          label: "Expiry date",
          searchable: true,
          filterKey: { expiry_date: "" },
          type: "dateField"
        },
        {
          field: "uploaded_by",
          label: "Uploaded By",
          searchable: true,
          visible: true,
          allStatusVals: this.users,
          initStatusVals: [],
          multiSelectFilter: true,
          type: "multiSelectFilter",
          filterKey: { uploaded_by: [] }
        },
        {
          field: "upload_date",
          label: "Uploaded Date",
          searchable: true,
          filterKey: { upload_date: "" },
          type: "dateField"
        },
        {
          field: "updated_by",
          label: "Last Updated By",
          searchable: true,
          visible: true,
          allStatusVals: this.users,
          initStatusVals: [],
          multiSelectFilter: true,
          type: "multiSelectFilter",
          filterKey: { updated_by: [] }
        },
        {
          field: "last_update",
          label: "Last Updated Date",
          searchable: true,
          filterKey: { last_update: "" },
          type: "dateField"
        },
        {
          field: "actions",
          label: "",
          sortable: 1,
          headerClass: "is-actions",
          cellClass: "is-actions",
          visible: true,
          searchable: true,
          type: "actionSearch",
          actionSearch: true,
          filterKey: { actions: "" }
        }
      ],
      DataManagementService: new DataManagementService(),
      customerDataService: new CustomerProfileDataService(),
      DataManagementCertificatesService: new DataManagementCertificatesService()
    };
  },
  mounted() {
    this.getAllSuppliersData();
    this.fetchUserData();
    this.fetchCertificateData();
    this.fetchCustomerData();
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"]),
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyUser() {
      return this.userGroups.includes(UserGroup.VIEW_ONLY);
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/import", name: "Import" }
      ];
    }
  },
  watch: {
    users(newValue) {
      this.fetchInternalUserData(newValue);
    },
    suppliers(newValue) {
      const supplierIndex = this.find_column_index("supplier_name");
      if (supplierIndex > -1) {
        this.columns[supplierIndex].allStatusVals = newValue;
      }
    },
    matchClicked(newVal, oldVal) {
      if (newVal !== oldVal) {
        // Reset only selection state without affecting filters or pagination
        this.map1 = new Map();
        this.checkedRows = [];
        this.isCheckedAll = false;
        this.checkedData = [];
        this.checkedDataMap = new Map();
        this.tableData = [];

        // Notify parent of cleared selections
        this.$emit("selectedRows", []);

        // Fetch fresh data with current query to preserve filters and pagination
        const queryToUse = this.query || "";
        this.fetchCertificateData(queryToUse);
      }
    }
  },
  methods: {
    manualMatchingCancel() {
      this.isManualMatchingModal = false;
    },
    handleDataMatched() {
      // Reset table data before fetching
      this.tableData = [];
      this.currentPage = 0;
      this.nextPageCursor = null;
      this.nextData = false;
      this.previousData = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedDataMap = new Map();
      // Refresh the certificate table immediately
      this.fetchCertificateData(this.query);
      // Show success message toast instead of modal dialog to avoid interruption
      this.$buefy.toast.open({
        message: "Data Matched Successfully!",
        type: "is-success",
        duration: 3000
      });
    },

    saveMatchedData(data) {
      console.log("Data to be matched and saved:", data);
      this.DataManagementCertificatesService.saveMatchedData(data).subscribe(
        () => {
          this.$buefy.toast.open({
            message: "Match completed successfully!",
            type: "is-success",
            duration: 2000
          });
          if (this.$refs.manualMatchingModal) {
            this.$refs.manualMatchingModal.triggerRefresh();
          }
        },
        e => {
          this.handleApiError(e);
        }
      );
    },
    getAllSuppliersData() {
      this.suppliersService.getAllSuppliersData().subscribe(
        response => {
          this.suppliers = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    showCamUserView() {
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      // check includes and replace
      this.query = this.query
        .replace(/cam_user=[^&]*&?/g, "")
        .replace(/&$/, "");
      this.query = this.query + "&cam_user=" + this.showCamUserData;

      if (this.query.includes("page=")) {
        // replace pagination page parameter from query string
        this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      }
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.PreviousPageCursor = null;
      this.displayedRecords = 0;
      this.currentPage = 0;
      this.nextData = false;
      this.fetchCertificateData(this.query);
    },
    downloadCertificate(data) {
      try {
        this.DataManagementCertificatesService.downloadCertificate(data.id)
          .then(response => {
            // Extract filename from Content-Disposition header or use default
            let filename = `certificate_${data.id}.pdf`;
            const contentDisposition = response.headers["content-disposition"];
            if (contentDisposition) {
              const filenameMatch = contentDisposition.match(
                /filename="?([^"\n\r]+)"?/i
              );
              if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1];
              }
            } else if (data.name) {
              // Use data.name if available, ensure it has .pdf extension
              filename = data.name.includes(".pdf")
                ? data.name
                : `${data.name}.pdf`;
            }

            // response.data is already a Blob due to responseType: 'blob'
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch(e => {
            this.$buefy.dialog.alert({
              title: "Download Error!",
              message: e.message || "Failed to download certificate",
              type: "is-danger",
              hasIcon: true,
              icon: "times-circle",
              iconPack: "fa",
              ariaRole: "alertdialog",
              ariaModal: true
            });
          });
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Download Error!",
          message: e.message || "An error occurred while downloading",
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    openCertificate() {
      this.editCertificate = null;
      this.showCertificateModal = true;
    },
    openEditCertificateModal(certificateData) {
      this.editCertificate = certificateData;
      this.viewCertificate = null;
      this.showCertificateModal = true;
    },
    openViewCertificateModal(certificateData) {
      this.viewCertificate = certificateData;
      this.editCertificate = null;
      this.showCertificateModal = true;
    },
    closeCertificateModal() {
      this.showCertificateModal = false;
      this.editCertificate = null;
      this.viewCertificate = null;
    },
    refreshCertificates() {
      // Reset table and reload data
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.nextData = false;
      this.fetchCertificateData();
    },
    fetchCertificateData(query = "", scrollDir) {
      this.isDataLoading = true;
      console.log("Fetching certificates with query:", query);
      this.DataManagementCertificatesService.get(query).subscribe(
        response => {
          console.log("API response for certificates:", response);
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }
          this.totalRecords = response["count"];
          let tempData = [];
          if (scrollDir == "next") {
            if (!this.nextPageCursor) {
              this.prepareData(response["results"], scrollDir);
            } else {
              tempData = [...this.tableData, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.tableData];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }
        },
        () => {
          this.nextData = false;
          this.isDataLoading = false;
        }
      );
    },
    prepareData(data) {
      const dataList = [];
      // Handle both array and object responses
      const records = Array.isArray(data) ? data : Object.values(data);
      for (const reportData of records) {
        // Format dates if they exist
        if (reportData["upload_date"]) {
          reportData["upload_date"] = this.dateToLocalDate(
            reportData["upload_date"]
          );
        }
        if (reportData["last_update"]) {
          reportData["last_update"] = this.dateToLocalDate(
            reportData["last_update"]
          );
        }
        reportData["actions"] = this.isEditAllowed;
        // Add file count for download icon to show (must be < 2)
        reportData["active_document_name_file_count"] = 1;
        dataList.push(reportData);
      }
      if (this.nextPageCursor == null) {
        this.tableData.push(...dataList);
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        this.tableData = dataList;
      }
      //if select all checkbox clicked the show all the data for the page as checked
      if (this.isCheckedAll) {
        this.checkedRows = this.tableData;
      } else {
        //else show the corresponding data from the dictionay map1
        const temp = [];
        // check if dictionary has value or not
        if (
          this.map1.get(this.currentPage) &&
          this.map1.get(this.currentPage).length > 0
        ) {
          //inserting data according to index of the current page
          this.map1.get(this.currentPage).forEach(element => {
            temp.push(this.tableData[element]);
          });
          this.checkedRows = temp;
        } else {
          this.checkedRows = [];
        }
      }
      this.isDataLoading = false;
    },
    getFileName(file) {
      const cleanFile = file.substring(file.lastIndexOf("/") + 1);
      return this.decodedString(cleanFile);
    },
    decodedString(encodedString) {
      // Decode the URL-encoded string
      return decodeURIComponent(encodedString);
    },
    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;
      const temp = this.nextPageCursor.split("?")[1].split("&");
      let query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      query_part = [...new Set(query_part)];
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query =
          query_part.join("&") + "&page=" + (this.currentPage + 1) + "&";
        this.query = "&" + this.query;
        this.fetchCertificateData(this.query, "next");
      }
    },
    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;
      const temp = this.PreviousPageCursor.split("?")[1].split("&");
      const query_part = temp.filter(function(value) {
        return value.indexOf("page=") == -1;
      });
      if (this.currentPage == 0 || this.currentPage == 1) {
        this.query = query_part.join("&") + "&page=1&";
        this.previousData = false;
      } else {
        this.query = query_part.join("&") + "&page=" + this.currentPage + "&";
      }
      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchCertificateData(this.query, "prev");
    },
    checkedAllData() {
      // For single row selection mode, "select all" is not supported
      // Always clear selections when this is triggered
      this.isCheckedAll = false;
      this.checkedRows = [];
      this.map1 = new Map();
      this.checkedDataMap = new Map();
      this.checkedData = [];
      this.$emit("selectedRows", []);
    },
    checkCheckBox(d) {
      // Guard against re-entrant calls caused by Circul8Table's localCheckedRows
      // watcher emitting 'clickcheck' synchronously when we update this.checkedRows.
      if (this._checkboxUpdating) return;
      this._checkboxUpdating = true;
      try {
        if (d.length > 0) {
          // Keep only the last selected item (most recent selection)
          const selectedRow = d[d.length - 1];
          // Skip if this row is already the only selection
          if (
            this.checkedData.length > 0 &&
            this.checkedData[0].id === selectedRow.id
          ) {
            return;
          }
          this.map1 = new Map();
          this.checkedDataMap = new Map();
          this.checkedData = [selectedRow];
          this.checkedRows = [selectedRow];

          const index = this.tableData.findIndex(object => {
            return selectedRow.id === object.id;
          });
          if (index !== -1) {
            this.map1.set(this.currentPage, [index]);
            this.checkedDataMap.set(this.currentPage, [selectedRow]);
          }
          this.isCheckedAll = false;
          this.$emit("selectedRows", this.checkedData);
        } else {
          // Skip if already empty
          if (this.checkedData.length === 0) return;
          this.checkedRows = [];
          this.checkedData = [];
          this.map1 = new Map();
          this.checkedDataMap = new Map();
          this.isCheckedAll = false;
          this.$emit("selectedRows", []);
        }
      } finally {
        this._checkboxUpdating = false;
      }
    },
    searchByFilter(filterQuery) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRows = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      filterQuery += "cam_user" + "=" + this.showCamUserData + "&";
      this.query = filterQuery;
      //      this.displayedRecords = 0;

      let query = "";
      // Maintaining sort column & order in separate varaibles instead of this.query as it becomes difficult to replace & maintain
      // sort column & order part of this.query string. We should maintain query params in associative array instead of string
      if (this.lastSortColumn) {
        query += "&order_field" + "=" + this.lastSortColumn;
        query += "&order_by" + "=" + this.lastSortOrder;
        query += "&" + this.query;
      } else {
        query = this.query;
      }
      this.fetchCertificateData(query);
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      this.query = this.query
        .replace(/cam_user=[^&]*&?/g, "")
        .replace(/&$/, "");
      this.query = this.query + "&cam_user=" + this.showCamUserData;

      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchCertificateData(this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },

    fetchInternalUserData(newValue) {
      const uploaded_by = this.find_column_index("uploaded_by");
      this.columns[uploaded_by]["allStatusVals"] = newValue;
      const updated_by = this.find_column_index("updated_by");
      this.columns[updated_by]["allStatusVals"] = newValue;
    },

    fetchCustomerData() {
      this.customerDataService.getCustomerListForImport().subscribe(
        response => {
          const data = response;
          const customerNameIndex = this.find_column_index("customer_name");
          this.columns[customerNameIndex].allStatusVals = data;
          this.customers = data;
        },
        e => {
          console.log(e);
        }
      );
    }
  }
};
</script>
